<app-si-dialog header="Create List" saveButtonText="Next" [saveButtonDisabled]="!type" (save)="next()">
	<ng-template appDialogBody>
		<div class="flex flex-wrap -mx-2 gap-0 p-4">
			<div class="w-full sm:flex-none sm:w-full header-container px-2">
				<div>
					<div>
						<div>
							<table class="table-class mb-0 si-table">
								<thead>
								<tr>
									<th class="flex-none w-full px-2">
										Select List
									</th>
									<th>
										&nbsp;
									</th>
								</tr>
								</thead>
								<tbody>
								<tr>
									<td class="row-height" (click)="openList('company')">
										Company List
									</td>
									<td class="text-right">
										<fa-icon [hidden]="type !== 'company'" class="py-0" [icon]="['fas', 'check']"></fa-icon>
									</td>
								</tr>
								<tr>
									<td class="row-height" (click)="openList('contact')">
										Contact List
									</td>
									<td class="text-right">
										<fa-icon [hidden]="type !== 'contact'" class="py-0" [icon]="['fas', 'check']"></fa-icon>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</app-si-dialog>
